const LOGO = (
  <img src="/assets/img/logo2.svg" alt="G-Museum" className="logo-svg" />
);

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-left">
        <a href="/" className="logotype" aria-label="G-Museum">
          {LOGO}
        </a>
      </div>
      <div className="footer-right">
        <div>
          <h3>Наша адреса</h3>
          <div className="footer-divider"></div>
          <p>Україна, 32000,</p>
          <p>Хмельницька область,</p>
          <p>Хмельницький район,</p>
          <p>м. Городок, вул. Тараса Шевченка, 20/1</p>
        </div>
        <div>
          <h3>Контакти</h3>
          <div className="footer-divider"></div>
          <p>Телефон: +380 (97) 814-79-45</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 Городоцький краєзнавчий музей G-Museum</p>
      </div>
    </footer>
  );
}
